import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import enJSON from "../locale/en-US.json";
import nlJSON from "../locale/nl-NL.json";

if (!localStorage.getItem("i18nextLng")) {
    localStorage.setItem("i18nextLng", "nl-NL");
}

const configuration = [
    { key: "en-US", label: "English", file: enJSON },
    { key: "nl-NL", label: "Nederlands", file: nlJSON },
];

export const settings = configuration.map(element => ({
    label: element.label,
    value: element.key,
}));

const resources = Object.fromEntries(configuration.map(x => [x.key, x.file]));

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: "nl-NL",
        detection: {
            order: ["querystring", "cookie", "localStorage", "navigator", "htmlTag"],
            caches: ["localStorage", "cookie"],
        },
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
